import { Grid } from "@material-ui/core";
import { useTokenAnalysisSelector } from "src/context/tokenAnalysisContext";
import BaseTable from "./BaseTable";
import { headerConfig } from "./config";

export default function TopTable() {
  const { top5PriceStable, top5AvgIncreasingScore, top5PriceIncrease, top5PriceDecrease } = useTokenAnalysisSelector(
    (state) => state.topAnalytic
  );

  return (
    <Grid container spacing={3} style={{ paddingTop: "1.5rem" }}>
      <Grid item md={6} xs={12}>
        <BaseTable
          tableId="top5PriceIncrease"
          title="Top Price Increased Tokens"
          tableHeaderConfig={headerConfig["top5PriceIncrease"]}
          data={top5PriceIncrease}
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <BaseTable
          tableId="top5PriceDecrease"
          title="Top Price Decreased Tokens"
          tableHeaderConfig={headerConfig["top5PriceDecrease"]}
          data={top5PriceDecrease}
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <BaseTable
          title="Top Stable Tokens"
          tableHeaderConfig={headerConfig["top5PriceStable"]}
          data={top5PriceStable}
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <BaseTable
          title="Top Average Score Increased Tokens"
          tableHeaderConfig={headerConfig["top5AvgIncreasingScore"]}
          data={top5AvgIncreasingScore}
        />
      </Grid>
    </Grid>
  );
}
